import { fovUploads, deleteFovUploadPath, createFovUploadPath } from 'helpers/globals'
import axios from 'api/config'

/** Called when getting all of the fov uploads of the current user */
export function getFovUploads() {
  return axios
    .get(fovUploads)
    .then(r => r.data)
}

/** Called when deleting a fov upload */
export function destroyFovUpload(id) {
  return axios
    .delete(deleteFovUploadPath(id))
    .then(r => r.data)
}

/** Called when creating a fov upload */
export function createFovUpload(params) {
  return axios
    .post(createFovUploadPath, params, { timeout: 58000, 'axios-retry': { retries: 1 } })
    .then(r => r.data)
}



// WEBPACK FOOTER //
// ./src/api/fovUploads.js